<template>
  <div>
    <ClientConclusionConclusionFrom
        v-if="(userCanAdd || userCanEdit) && showForm"
        :conclusion="conclusion"
        v-on:submit="submitForm"
        v-on:cancel="closeForm"/>

    <div class="mb-5">
      <div class="py-3 px-4 border bg-light font-weight-bold text-primary position-relative">
        Заключения

        <div
          v-if="userCanAdd"
          class="position-absolute"
          style="right:10px;top:8px;">
          <button
              class="btn btn-primary"
              @click="showForm = true">
            Новое заключение
          </button>
        </div>
      </div>

      <ClientConclusionConclusionList
          v-on:select="selectConclusion"
          :items="data" />
    </div>
  </div>
</template>

<script>
import ClientConclusionConclusionList from './conclusion/List';
import ClientConclusionConclusionFrom from './conclusion/Form';
import formatDate from '../../../utils/formatDate';

export default {
  name: 'ClientConclusionConclusion',

  props: ['conclusions', 'submitConclusion', 'userCanAdd', 'userCanEdit'],

  components: {ClientConclusionConclusionList, ClientConclusionConclusionFrom},

  data() {
    return {
      error: '',
      success: '',
      conclusionId: null,
      showForm: false,
    };
  },

  computed: {
    data() {
      const data = this.conclusions.map(({dateFrom, text, note, id, createdBy}) => {
        return {dateFrom, text, note, id, createdBy};
      });

      data.sort((a, b) => b.dateFrom.getTime() - a.dateFrom.getTime());

      return data;
    },

    conclusion() {
      return this.conclusions.find(i => i.id === this.conclusionId);
    },
  },

  methods: {
    selectConclusion(id) {
      if (!this.userCanEdit) {
        return false;
      }

      this.showForm = true;
      this.conclusionId = id;
    },

    closeForm() {
      this.showForm = false;
      this.conclusionId = null;
    },

    formatDate(date, format) {
      return formatDate(date, format);
    },


    async submitForm(data) {
      await this.submitConclusion(data);

      this.closeForm();
    },
  },
};
</script>
